module.exports = __webpack_public_path__ + "media/images/profile/compare-ed9ca77bc074b068e1b60fa1ba584a54.svg";